export default "__VITE_ASSET__DkLLpeZA__"